import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, ToggleSwitch } from 'is24-corecss'
import { IconS24AlertTriangle24Filled } from '@is24/cosma-ui-icons'

import { DepositGuaranteeModal } from './DepositGuaranteeModal'
import styles from './DepositGuarantee.module.css'

type DepositGuaranteeProps = {
  isAllowed: boolean
  onChange: (isAllowed: boolean) => void
  showDetailsLink?: boolean
}

export const DepositGuarantee: React.FC<DepositGuaranteeProps> = ({ isAllowed, onChange, showDetailsLink = false }) => {
  const { t } = useTranslation()
  const [isModalOpen, setIsModalOpen] = useState(false)

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles.cardRow}>
          <div className={styles.copy}>
            <div className={styles.titleRow}>
              <span className='font-body-medium-bold'>{t('wizard.screen.costs.depositGuarantee.title')}</span>
              <span className={`${styles.badge} font-body-small-bold`}>
                {t('wizard.screen.costs.depositGuarantee.badge')}
              </span>
            </div>
            <div className='font-body-small-regular'>{t('wizard.screen.costs.depositGuarantee.description')}</div>
          </div>
          <ToggleSwitch
            key={isAllowed ? 'allowed' : 'not-allowed'}
            id='deposit-guarantee-toggle'
            className={styles.toggle}
            label={
              <span className={styles.visuallyHidden}>{t('wizard.screen.costs.depositGuarantee.toggleLabel')}</span>
            }
            defaultChecked={isAllowed}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => onChange(event.currentTarget.checked)}
          />
        </div>
        {showDetailsLink && (
          <Link as='button' type='button' variant='weak' onClick={() => setIsModalOpen(true)}>
            {t('wizard.screen.costs.depositGuarantee.showMore')}
          </Link>
        )}
      </div>
      {!isAllowed && (
        <div role='alert' className={styles.warning}>
          <IconS24AlertTriangle24Filled
            width={16}
            height={16}
            aria-label={t('wizard.screen.costs.depositGuarantee.warningIconLabel')}
          />
          <span className={`${styles.warningText} font-body-small-regular`}>
            {t('wizard.screen.costs.depositGuarantee.warning')}
          </span>
        </div>
      )}
      {showDetailsLink && <DepositGuaranteeModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />}
    </div>
  )
}
